/**
 * Import required libraries
 */
import React, { useMemo } from "react";
import { Link, useHistory } from "react-router-dom";
import { useTheme} from "@material-ui/core";

/**
 * Import required elements
 */
import ScopedCssBaseline from "@material-ui/core/ScopedCssBaseline"
import { ThisGroupLogo } from 'Components';
import Users from "./Users";
import LandingMenu from "./Landing";
import Language from "./Language";
import ProjectNavbar from "./ProjectNavbar";
// Material-ui icons
import {
  ViewList as ShowColumnIcon,
  Cached as ClearIcon
} from "@material-ui/icons";
// styles
import styles from "./styles";

function GroupLogo(props) {
  const theme = useTheme()
  const classes = styles()
  return (
    <div className={classes.linkContainer}>
      <Link to="/" className={classes.Link}>
        <ThisGroupLogo
          backgroundColor={theme.palette.logoBackground}
        />
      </Link>
    </div>
  )
}

/**
 * AppBar Render JSX
 */
const AppBar = props => {
  let { authenticated, navigation, previewColor, navmenu, openNavmenu } = props;

  let init = useMemo(() => {
    return ["init", "login"].includes(navigation);
  }, [navigation])

  const history = useHistory()

  // CSS classnames
  const classes = styles()

  return (
    <ScopedCssBaseline>
      <div className={classes.AppBar}
        style={previewColor ? { backgroundColor: previewColor } : null}
      >
        <div className={classes.LeftSide}>
          <GroupLogo />
          {authenticated &&
            !["permanent", "persistent"].includes(navmenu.variant) ? (
              <ShowColumnIcon
                className={classes.menuIcon}
                onClick={openNavmenu}
              />
            ) : null
          }
          {authenticated ? <ProjectNavbar /> : null}
        </div>

        <div className={classes.Center}>
          {navigation === "login" ? <LandingMenu /> : null}
        </div>

        <div className={classes.RightSide}>
        
          {process.env.NODE_ENV === "development" ?
            // dev only: button to clear browser storage
            <ClearIcon className={classes.clearDev}
              onClick={e => {
                localStorage.clear()
                sessionStorage.clear()
                global.indexedDB.deleteDatabase("cache")
                history.push("/")
                global.location.reload(true)
              }}
            />
            : null
          }
          <Language />
          {authenticated && !init ? <Users /> : null}
        </div>
      </div>
    </ScopedCssBaseline>
  );
};

export default AppBar;
